<template>
  <div
    :style="{ display: show ? '' : 'none' }"
    class="menu-item"
    @click="onRoutingJump"
  >
    <img :src="menu.img" />
    <span>{{ menu.title }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import wx from "weixin-js-sdk";

export default {
  components: {},
  props: {
    menu: { type: Object, default: {} },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapGetters({ permissions: "global/permissions" }),
  },
  created() {},
  mounted() {
    this.isShow();
  },
  methods: {
    isShow() {
      (this.menu.permiss || []).forEach((item) => {
        if (!this.permissions.includes(item)) {
          this.show = false;
        }
      });
    },
    onRoutingJump() {
      if (this.menu.to) {
        this.$router.push(this.menu.to);
      } else {
        this.qrScan();
      }
    },
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let resultStr = res.resultStr;
          let index = resultStr.indexOf(`CODE_128,`);
          if (index > -1) {
            let len = resultStr.length;
            resultStr = resultStr.slice(index + 9, len - 1);
          }
          if (resultStr.indexOf(/pamera/) != -1) {
            const arr = resultStr.split("/pamera/");
            const str = arr[arr.length - 1];
            This.$router.push("/pamera/" + str);
          } else if (resultStr.startsWith("http")) {
            This.$toast.fail("非法链接");
          } else {
            This.$router.push("/pamera/" + resultStr);
          }
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.menu-item {
  width: calc(100% / 3 - 2px);
  height: 130px;
  background: rgba(111, 111, 111, 0.1);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #fff;
  & > img {
    height: 45px;
    width: 45px;
  }
  & > span {
    margin-top: 8px;
    text-align: center;
  }
}
</style>
